import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import $store from '../store'
const { module } = window.env.VITE_DATA
const router = new VueRouter({
    routes: [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('@/views/home.vue'),
            meta: {
                title: '首页',
                ignoreAccess: true
            }
        },
        {
            path: '/introduce',
            name: 'introduce',
            component: () => import('@/views/introduce.vue'),
            meta: {
                title: '产品介绍',
                ignoreAccess: true,
                mId: module.product,
                noTrack: true,
            }
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import('@/views/contact.vue'),
            meta: {
                title: '联系我们',
                ignoreAccess: true
            }
        },
        {
            path: '/introduceDetail/:introduceId',
            name: 'introduceDetail',
            props: true,
            component: () => import('@/views/introduceDetail.vue'),
            meta: {
                title: '产品介绍列表',
                ignoreAccess: true,
                mId: module.product,
                noTrack: true,
            }
        },
        {
            path: '/introduceDetail2/:introduceId2/:introduceId',
            name: 'introduceDetail2',
            props: true,
            component: () => import('@/views/introduceDetail2.vue'),
            meta: {
                title: '产品介绍详情',
                ignoreAccess: true,
                mId: module.product,
                noTrack: true,
            }
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('@/views/about.vue'),
            meta: {
                title: '关于我们',
                ignoreAccess: true
            }
        },
        {
            path: '/market',
            name: 'market',
            component: () => import('@/views/market.vue'),
            meta: {
                title: '市场应用及案例',
                ignoreAccess: true,
                mId: module.market,
                noTrack: true,
            }
        },
        {
            path: '/marketDetail/:marketId',
            name: 'marketDetail',
            props: true,
            component: () => import('@/views/marketDetail.vue'),
            meta: {
                title: '市场应用及案例详情',
                ignoreAccess: true,
                mId: module.market,
                noTrack: true,
            }
        },
        {
            path: '/marketDetail2/:childMarketNameId/:marketNameId',
            name: 'marketDetail2',
            props: true,
            component: () => import('@/views/marketDetail2.vue'),
            meta: {
                title: '市场应用及案例子市场详情',
                ignoreAccess: true,
                mId: module.market,
                noTrack: true,
            }
        },
        {
            path: '/pdfView/:hId/:rId',
            // path: '/pdfView',
            name: 'pdfView',
            props: true,
            component: () => import('@/views/pdfView.vue'),
            meta: {
                title: 'pdf预览',
                ignoreAccess: true,
                mId: module.download,
                noTrack: true,
            }
        },
        {
            path: '/download',
            name: 'download',
            component: () => import('@/views/download.vue'),
            meta: {
                title: '资料下载',
                ignoreAccess: true,
                mId: module.download,
                noTrack: true,
            }
        },
        {
            path: '/class',
            name: 'class',
            component: () => import('@/views/class.vue'),
            meta: {
                title: '直播看点',
                ignoreAccess: true,
                mId: module.liveClass,
                noTrack: true,
            }
        },
        {
            path: '/my',
            name: 'my',
            component: () => import('@/views/my.vue'),
            meta: {
                title: '个人中心'
            }
        },
        {
            path: '/collection',
            name: 'collection',
            component: () => import('@/views/collection.vue'),
            meta: {
                title: '我的收藏'
            }
        },
        {
            path: '/binding',
            name: 'binding',
            component: () => import('@/views/binding.vue'),
            meta: {
                title: '1688绑定'
            }
        },
        {
            path: '/record',
            name: 'record',
            component: () => import('@/views/record.vue'),
            meta: {
                title: '积分记录'
            }
        },
        {
            path: '/gift',
            name: 'gift',
            component: () => import('@/views/gift.vue'),
            meta: {
                title: '积分兑换'
            }
        },
        {
            path: '/utils',
            name: 'utils',
            component: () => import('@/views/utils.vue'),
            meta: {
                title: '百宝箱'
            }
        },
        {
            path: '/address',
            name: 'address',
            component: () => import('@/views/address.vue'),
            meta: {
                title: '收货地址'
            }
        },
        {
            path: '/addressAdd',
            name: 'addressAdd',
            component: () => import('@/views/addressAdd.vue'),
            meta: {
                title: '收货地址新增'
            }
        },
        {
            path: '/address/edit/:id',
            name: 'addressEdit',
            component: () => import('@/views/addressAdd.vue'),
            meta: {
                title: '收货地址修改'
            }
        },
        {
            path: '/redirect',
            name: 'redirect',
            component: () => import('@/views/redirect.vue'),
            meta: {
                ignoreAccess: true
            }
        },
        {
            path: '/errorPage',
            name: 'errorPage',
            component: () => import('@/views/ErrorPage.vue'),
            meta: {
                ignoreAccess: true
            }
        },
        {
            path: '*',
            redirect: {
                name: 'home'
            }
        }
    ]
})
// 需要验证权限的话开启
router.beforeEach(async (to, from, next) => {
    if (to.meta.ignoreAccess) {
        next()
    } else {
        const isValid = await $store.dispatch('checkAccess', {
            redirect: '/my'
        })
        if (isValid) {
            next()
        } else {
            next({ name: 'errorPage', query: { type: 0 } })
        }
    }
})
export default router
